// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".search-bar[data-v-5056ad27]{display:flex;flex-direction:row;margin-bottom:1rem;margin-top:1rem}.search-bar button[data-v-5056ad27]{--tw-bg-opacity:1;align-items:center;background-color:#6369d1;background-color:rgba(99,105,209,var(--tw-bg-opacity));display:flex;height:50px;justify-content:center;width:50px}.search-bar .icon[data-v-5056ad27]{height:16px;width:16px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
